import type { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';
import { createNotification } from 'modules/toast-notifications/actions';
import { getSanitizedName } from 'utils/fileName';

import { uploadDocumentFailure, uploadDocumentSuccess } from '../actions/general';
import * as actionTypes from '../actionTypes/general';
import type { UploadDocumentAction } from '../types';

function* uploadCustomerDocument({ payload }: UploadDocumentAction) {
  const { request, file, ...params } = payload;
  try {
    if (file?.type !== 'application/pdf') {
      throw new Error('Only pdf file is accepted to perform the upload !');
    }

    const fileName = getSanitizedName(file.name);
    const postRequest = {
      ...request,
      params: { fileName },
      data: file,
    };
    const { data: response } = (yield call(() => restClient.request<{ id: string }>(postRequest))) as AxiosResponse<{ id: string }>;
    yield put(uploadDocumentSuccess({ id: response.id, ...params, fileName: file.name }));
  } catch (error) {
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'page.config.admin.dealer.update.usersImport.failure',
          defaultMessage: 'An error has occurred while uploading the file',
        },
      })
    );
    yield put(uploadDocumentFailure({ error, name: params.name }));
  }
}

export default function* generalSagas() {
  yield takeLatest(actionTypes.UPLOAD_DOCUMENT, uploadCustomerDocument);
}
